import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconChevronUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.99805 13.8639C6.99856 13.7292 7.02629 13.596 7.07956 13.4723C7.13283 13.3485 7.21054 13.2368 7.30805 13.1439L11.308 9.2839C11.495 9.10067 11.7463 8.99804 12.008 8.99804C12.2698 8.99804 12.5211 9.10067 12.708 9.2839L16.708 13.2839C16.8013 13.3771 16.8752 13.4878 16.9257 13.6096C16.9762 13.7315 17.0021 13.862 17.0021 13.9939C17.0021 14.1258 16.9762 14.2563 16.9257 14.3781C16.8752 14.5 16.8013 14.6107 16.708 14.7039C16.6148 14.7971 16.5041 14.8711 16.3823 14.9216C16.2605 14.972 16.1299 14.998 15.998 14.998C15.8662 14.998 15.7356 14.972 15.6138 14.9216C15.492 14.8711 15.3813 14.7971 15.288 14.7039L11.998 11.4039L8.69805 14.5839C8.51068 14.7701 8.25723 14.8747 7.99305 14.8747C7.72886 14.8747 7.47541 14.7701 7.28805 14.5839C7.19416 14.4893 7.12014 14.3768 7.07034 14.2532C7.02054 14.1295 6.99596 13.9972 6.99805 13.8639Z",
		fill: "currentColor"
	})
});
export default SvgIconChevronUp;
